import { useWindowWidth } from './useWindowWidth';

export const useResponsiveDimensions = () => {
  const width = useWindowWidth();

  return {
    isMaxTV: width > 1930,
    isTV: width > 1700,
    isBigTablet: width <= 1200,
    isTablet: width <= 992,
    isMobile: width <= 768,
  };
};
